// extracted by mini-css-extract-plugin
module.exports = {"typography":"RichContentPreview_typography__4tZXs","inlineEmoji":"RichContentPreview_inlineEmoji__s7Lt7"};